import { Box } from '@startuptools/ui/Box';
import { Card } from '@startuptools/ui/Card';
import { Stack } from '@startuptools/ui/Stack';
import { Tooltip } from '@startuptools/ui/Tooltip';
import { Typography, type TypographyProps } from '@startuptools/ui/Typography';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { type ComponentProps } from 'react';

export const InfoCard = ({
  label,
  value,
  valueProps,
  secondaryValue,
  secondaryValueProps,
  tooltip,
  sx,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
  valueProps?: TypographyProps;
  secondaryValue?: React.ReactNode;
  secondaryValueProps?: TypographyProps;
  tooltip?: React.ReactNode;
  sx?: ComponentProps<typeof Card>['sx'];
}) => {
  return (
    <Card
      sx={{ boxShadow: theme => theme.shadow.sm, backgroundColor: 'white', flexBasis: 'auto', minWidth: 150, ...sx }}
      variant="plain"
    >
      <Stack spacing={1}>
        <Stack direction="row" spacing={1}>
          <Typography fontSize="14" fontWeight={600}>
            {label}
          </Typography>
          {tooltip && (
            <Tooltip
              arrow
              variant="outlined"
              title={
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: 320,
                    justifyContent: 'center',
                    p: 1,
                  }}
                >
                  <Box sx={{ display: 'flex', gap: 1, width: '100%', mt: 1 }}>
                    <HelpOutlineIcon color="success" />
                    <Box>{tooltip}</Box>
                  </Box>
                </Box>
              }
            >
              <HelpOutlineIcon />
            </Tooltip>
          )}
        </Stack>

        <Stack direction="row" spacing={1} alignItems="baseline">
          <Typography fontSize="20px" fontWeight={600} color="neutral" {...valueProps}>
            {value}
          </Typography>
          <Typography fontWeight="bold" fontSize="14px" {...secondaryValueProps}>
            {secondaryValue}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};
